import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import searchFilter from '../utilities/search-filter';
import {FormattedMessage} from 'react-intl';

export default React.memo(({error}) => {
  const location = useLocation();
  if (error?.toString()?.includes('Access Denied')) {
    return (
      <p className='text-lg padding-2rem color-gray-900 medium'>
        <FormattedMessage defaultMessage='Looks like your session has expired.'/> <Link to={`/sign-out${searchFilter(location.search)}`}><FormattedMessage defaultMessage='Please sign in again'/>.</Link>
      </p>
    );
  }
  throw error;
});

